import React from "react";
import { Skeleton, TableCell, TableRow } from "@mui/material";

export interface TableSkeletonProps {
  rows?: number;
  columns: number;
}

/**
 * Skeleton rows for a loading DataTable — premium feel instead of a spinner.
 * Render inside a <TableBody>.
 */
export default function TableSkeleton({ rows = 6, columns }: TableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <TableRow key={r}>
          {Array.from({ length: columns }).map((_, c) => (
            <TableCell key={c}>
              <Skeleton
                variant="text"
                width={c === 0 ? "60%" : `${40 + ((r + c) % 4) * 12}%`}
                height={22}
                sx={{ borderRadius: 1 }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
